module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dCFFb"))).then(() => parcelRequire('1iHdE'));